import { TripContext } from 'contexts'
import { useContext } from 'react'
import { ReturnItem } from 'services/types'
import { VerifiedMethod } from './enums'

export const useReturnItemService = () => {

    const tripContext = useContext(TripContext)

    const verifyReturnItem = async (returnItem: ReturnItem, method: VerifiedMethod): Promise<void> => {
        let updatedReturnItem = {
            ...returnItem,
            verifiedMethod: method,
            verifiedTime: returnItem.verifiedTime ?? new Date()
        }
        tripContext.returnItems.put(updatedReturnItem)
    }

    const isValidReturnSticker = (returnSticker: number | null): boolean => returnSticker != null && !isNaN(returnSticker) && returnSticker.toString().length <= 9
   
    const isReturnStickerDuplicate = (returnSticker: number | null,
        returnItemId: number | null = null,
        orderItemChangeId: number | null = null,
        mispicksItemId: number | null = null,
        catchWeightId: number | null = null): boolean => {

        var returnItems = getReturnStickers(tripContext.returnItems.toArray() as any[], returnItemId);
        var orderItemChanges = getReturnStickers(tripContext.orderItemChanges.toArray() as any[], orderItemChangeId);
        var mispicks = getReturnStickers(tripContext.mispicks.toArray() as any[], mispicksItemId);
        var catchWeights = getReturnStickers(tripContext.catchWeights.toArray() as any[], catchWeightId);

        let returnStickers = returnItems.concat(orderItemChanges).concat(mispicks).concat(catchWeights);

        for (const rs of returnStickers) {
            if (rs === returnSticker)
                return true;
        }
        
        return false;
    }

    const getReturnStickers = (tripContextItems: any[], id: number | null) => {
        var items = tripContextItems.filter(x => x.returnSticker !== null && x.returnSticker !== 0);
        if (id !== null) items = items.filter(x => x.id !== id);
        return items.map(x => x.returnSticker!);
    }

    const isReturnItemCompleted = (returnItem: ReturnItem): boolean => {
        var isDuplicate = isReturnStickerDuplicate(returnItem.returnSticker, returnItem.id);

        if (isDuplicate)
            return false;

        const hasReturnStickerOrComment: boolean = isValidReturnSticker(returnItem.returnSticker) || returnItem.reasonForNoSticker != null
        const hasChangeReasonCode: boolean = returnItem.changeReasonCode != null
        if (returnItem.countedQuantity == returnItem.returnQuantity)
            return hasReturnStickerOrComment
        else if (returnItem.countedQuantity == 0)
            return hasChangeReasonCode
        else
            return hasReturnStickerOrComment && hasChangeReasonCode
    }

    const returnItemsNotCompletedCount = (returnItems: ReturnItem[]): number => {
        let notCompletedCount: number = 0
        for (const returnItem of returnItems) {
            if (!isReturnItemCompleted(returnItem)) {
                notCompletedCount++
            }
        }
        return notCompletedCount
    }

    return {
        verifyReturnItem: verifyReturnItem,
        isReturnItemCompleted: isReturnItemCompleted,
        returnItemsNotCompletedCount: returnItemsNotCompletedCount,
        isValidReturnSticker: isValidReturnSticker,
        isReturnStickerDuplicate: isReturnStickerDuplicate
    }
}